import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { SurveyorService } from './../../../services/SurveyorService/surveyor.service';
import jsPDF from 'jspdf';
declare let $: any;
@Component({
    selector: 'app-videos',
    templateUrl: './videos.component.html',
    styleUrls: ['./videos.component.css'],
    standalone: false
})
export class VideosComponent implements OnInit {

  constructor(private surveyorService: SurveyorService) { }
  @Input() LoginDetails: any;
  @Input() ClaimDetail: any;
  VideoDetails: any = [];
  VideoUrl: string = '';
  RegNo: string = '';
  ErrorMsg: string = '';
  clickCount = 0;
  ScreenshotFromVideo: any;
  canvas: any;
  createImageFromVideo:  any;
  Video: any;
  dataLink: any[] = [];
  newPDFDoc: any;
  captureDisabled: boolean = true;
  screenshotDisabled: boolean = false;
  private hasBoundCaptureHandler: boolean = false;
  private reusableCanvas?: HTMLCanvasElement;
  // Tab state
  selectedTab: string = 'existing';
  InspectionVideoDetails: any = [];
  InspectionVideoUrl: string = '';
  dataLinknstp : any =[];
  inspectionId : any ;
  screenshotDisablednstp: boolean = false;
  captureDisablednstp: boolean = true;
  // Combined screenshots across all videos
  allScreenshots: { id: string, src: string, source: 'existing' | 'inspection', videoIndex: number }[] = [];
  currentExistingVideoIndex: number = -1;
  currentInspectionVideoIndex: number = -1;
  selectedExistingIndex: number = -1;
  selectedInspectionIndex: number = -1;
  get canGenerateCombinedExisting(): boolean {
    const indices = new Set<number>();
    for (const s of this.allScreenshots) {
      if (s.source === 'existing') indices.add(s.videoIndex);
    }
    return indices.size > 1;
  }
  get canGenerateCombinedInspection(): boolean {
    const indices = new Set<number>();
    for (const s of this.allScreenshots) {
      if (s.source === 'inspection') indices.add(s.videoIndex);
    }
    return indices.size > 1;
  }
  ngOnInit(): void {
    // if(this.ClaimDetail.ClaimId){
    //   this.GetVideoDetails()
    // }
  }

  private createThumbWrapper(dataUrl: string, id: string, source: 'existing' | 'inspection', videoIndex: number, containerSelector: string) {
    const wrapper = document.createElement('div');
    wrapper.setAttribute('data-id', id);
    wrapper.setAttribute('style', 'position: relative; display: inline-block; margin: 0 5px;');

    const label = document.createElement('span');
    label.textContent = 'V' + String(videoIndex + 1) + (source === 'inspection' ? '' : '');
    label.setAttribute('style', 'position:absolute;left:2px;top:2px;background:#007bff;color:#fff;font-size:10px;padding:1px 3px;border-radius:3px');

    const closeBtn = document.createElement('span');
    closeBtn.textContent = '×';
    closeBtn.setAttribute('title','Remove');
    closeBtn.setAttribute('style', 'position:absolute;right:2px;top:2px;background:rgba(0,0,0,0.6);color:#fff;font-size:12px;line-height:12px;width:14px;height:14px;text-align:center;border-radius:50%;cursor:pointer');

    const thumb = document.createElement('img');
    thumb.src = dataUrl;
    thumb.setAttribute('style', 'width: 50px;height: 50px;border:3px solid #d2d6de;border-radius:6px');

    closeBtn.addEventListener('click', () => {
      try { wrapper.remove(); } catch {}
      if (source === 'existing') {
        const linkIdx = this.dataLink.indexOf(dataUrl);
        if (linkIdx > -1) this.dataLink.splice(linkIdx, 1);
      } else {
        const linkIdx = this.dataLinknstp.indexOf(dataUrl);
        if (linkIdx > -1) this.dataLinknstp.splice(linkIdx, 1);
      }
      const allIdx = this.allScreenshots.findIndex(s => s.id === id);
      if (allIdx > -1) this.allScreenshots.splice(allIdx, 1);
    });

    wrapper.appendChild(thumb);
    wrapper.appendChild(label);
    wrapper.appendChild(closeBtn);

    const container = $(containerSelector);
    container.prepend(wrapper);

    container.css({
      'padding':'10px',
      'overflow':'auto',
      'white-space':'nowrap',
      'border':'1px solid #ddd',
      'border-radius':'5px',
      'margin-top':'5px',
      'margin-bottom':'5px'
    });
  }

  private rebuildExistingThumbnails() {
    const index = this.currentExistingVideoIndex >= 0 ? this.currentExistingVideoIndex : (this.selectedExistingIndex >= 0 ? this.selectedExistingIndex : 0);
    const shots = (this.allScreenshots || []).filter(s => s.source === 'existing' && s.videoIndex === index);
    this.dataLink = shots.map(s => s.src);
    try { $('#screenshot').empty(); } catch {}
    for (let i = shots.length - 1; i >= 0; i--) {
      const s = shots[i];
      this.createThumbWrapper(s.src, s.id, s.source, s.videoIndex, '#screenshot');
    }
  }

  private rebuildInspectionThumbnails() {
    const index = this.currentInspectionVideoIndex >= 0 ? this.currentInspectionVideoIndex : (this.selectedInspectionIndex >= 0 ? this.selectedInspectionIndex : 0);
    const shots = (this.allScreenshots || []).filter(s => s.source === 'inspection' && s.videoIndex === index);
    this.dataLinknstp = shots.map(s => s.src);
    try { $('#screenshotnstp').empty(); } catch {}
    for (let i = shots.length - 1; i >= 0; i--) {
      const s = shots[i];
      this.createThumbWrapper(s.src, s.id, s.source, s.videoIndex, '#screenshotnstp');
    }
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['ClaimDetail'] && this.VideoDetails.length == 0 && this.ClaimDetail.ClaimId != 0){
      this.GetVideoDetails()
    }
    // Load inspection videos when claim detail changes
    if(changes['ClaimDetail'] && this.ClaimDetail.ClaimId != 0){
      this.GetInspectionVideoDetails();
    }
  }

  GetVideoDetails() {
    let reqData = `${this.ClaimDetail.ClaimId}/1`
    this.surveyorService.GetInsurerVideoDetails(reqData).subscribe((res)=>{
      if(res.Data!=null){
          this.VideoDetails = res.Data;
          this.GetVideoURl(this.VideoDetails[0]);
          this.selectedExistingIndex = 0;
          this.currentExistingVideoIndex = 0;
          this.RegNo = this.VideoDetails[0].RegistrationNo;

      } else {

          this.ErrorMsg = "Error : Something went wrong!";
      }
    })
  }

  OpenVideo(Video: any, index?: number) {
    if (typeof index === 'number') {
      this.currentExistingVideoIndex = index;
      this.selectedExistingIndex = index;
    }
    this.GetVideoURl(Video)
  };

  GetVideoURl(Video: any){
    this.surveyorService.getVideoLink(Video.ClaimID, btoa(Video.EncAppVideoID)).subscribe((data: any) => {
      this.VideoUrl = data.Data;
      // Reset video UI and force the video element to reload the new source
      setTimeout(() => {
        try {
          const vidEl = document.getElementById('video') as HTMLVideoElement | null;
          if (vidEl) {
            // pause, set src and reload to ensure browser picks up the new URL
            vidEl.pause();
            vidEl.src = this.VideoUrl || '';
            // remove any cached screenshots
            this.dataLink = [];
            if (typeof $ !== 'undefined') {
              try { $('#screenshot').empty(); } catch(e){}
            }
            vidEl.load();
            try { this.rebuildExistingThumbnails(); } catch {}
          }
        } catch (e) {
          // swallow DOM errors
        }
      }, 0);
    },
    (error) => {
      this.VideoUrl = '';
    })
  }

  // Inspection video functions (separate from existing videos)
  GetInspectionVideoDetails(){
    // let reqData = `${this.ClaimDetail.ClaimId}/inspection`;
    // NOTE: adjust the service/api method if there's a dedicated endpoint. Using same service as placeholder.
    this.surveyorService.GetInspectionVideoDetails().subscribe((res:any)=>{
      if(res && res.Data){
        this.InspectionVideoDetails = res.Data;
        if(this.InspectionVideoDetails.length>0){
          this.OpenInspectionVideo(this.InspectionVideoDetails[0]);
          this.selectedInspectionIndex = 0;
          this.currentInspectionVideoIndex = 0;
        }
      }
    }, (err:any)=>{
      this.InspectionVideoDetails = [];
    })
  }

  OpenInspectionVideo(insp: any, index?: number){
    this.InspectionVideoUrl = insp?.TemporaryVideoURL;
    this.inspectionId = insp?.InspectionId;
    if (typeof index === 'number') {
      this.currentInspectionVideoIndex = index;
      this.selectedInspectionIndex = index;
    }
    // switch to inspection tab when opening
    this.selectedTab = 'inspection';

    // reset video UI and force the inspection video element to reload
    setTimeout(() => {
      try {
        const inspEl = document.getElementById('inspectionVideo') as HTMLVideoElement | null;
        if (inspEl) {
          inspEl.pause();
          inspEl.src = this.InspectionVideoUrl || '';
          this.dataLinknstp = [];
          if (typeof $ !== 'undefined') {
            try { $('#screenshot').empty(); } catch(e){}
          }
          inspEl.load();
          try { this.rebuildInspectionThumbnails(); } catch {}
        }
      } catch (e) {
        // ignore
      }
    }, 0);
    return;

  }

  selectTab(tab: string){
    this.selectedTab = tab;
    this.captureDisabled = true;
    this.screenshotDisabled = false;
    this.captureDisablednstp = true;
    this.screenshotDisablednstp = false;
    setTimeout(() => {
      try {
        if (tab === 'existing') {
          if (this.VideoDetails && this.VideoDetails.length > 0) {
            this.selectedExistingIndex = 0;
            this.currentExistingVideoIndex = 0;
            this.rebuildExistingThumbnails();
            // ensure capture handler is bound after tab switch
            try { $("#capture").off('click'); this.hasBoundCaptureHandler = false; } catch {}
          }
        } else if (tab === 'inspection') {
          if (this.InspectionVideoDetails && this.InspectionVideoDetails.length > 0) {
            this.selectedInspectionIndex = 0;
            this.currentInspectionVideoIndex = 0;
            this.rebuildInspectionThumbnails();
            try { $("#capturenstp").off('click'); } catch {}
          }
        }
      } catch {}
    }, 0);
  }

  takeScreen() {
    this.captureDisabled = false
    this.screenshotDisabled = true

    const initializeScreenshot = () => {
      this.ScreenshotFromVideo = $("#screenshot");
      this.Video = $("#video").get(0);

      if (!this.reusableCanvas) {
        this.reusableCanvas = document.createElement("canvas");
        this.reusableCanvas.setAttribute('crossOrigin', 'anonymous');
      }

      if (!this.hasBoundCaptureHandler) {
        const captureImage = () => {
          if (!this.Video) return;
          const videoEl = this.Video as HTMLVideoElement;
          const canvas = this.reusableCanvas as HTMLCanvasElement;
          canvas.width = videoEl.videoWidth;
          canvas.height = videoEl.videoHeight;
          const ctx = canvas.getContext('2d');
          if (!ctx) return;
          ctx.drawImage(videoEl, 0, 0, canvas.width, canvas.height);

          // Use selected quality (default 0.4)
          let quality = 0.4;
          try {
            const qualitySel: any = document.getElementById('quality');
            if (qualitySel && qualitySel.value) {
              const parsed = parseFloat(qualitySel.value);
              if (!isNaN(parsed)) quality = parsed;
            }
          } catch {}

          const dataUrl = canvas.toDataURL('image/jpeg', quality);
          this.dataLink.push(dataUrl);

          const id = Date.now().toString() + Math.random().toString(36).slice(2);
          const vidIdx = this.currentExistingVideoIndex >= 0 ? this.currentExistingVideoIndex : 0;
          this.allScreenshots.push({ id, src: dataUrl, source: 'existing', videoIndex: vidIdx });

          const wrapper = document.createElement('div');
          wrapper.setAttribute('data-id', id);
          wrapper.setAttribute('style', 'position: relative; display: inline-block; margin: 0 5px;');

          const label = document.createElement('span');
          label.textContent = 'V' + String(vidIdx + 1);
          label.setAttribute('style', 'position:absolute;left:2px;top:2px;background:#007bff;color:#fff;font-size:10px;padding:1px 3px;border-radius:3px');

          const closeBtn = document.createElement('span');
          closeBtn.textContent = '×';
          closeBtn.setAttribute('title','Remove');
          closeBtn.setAttribute('style', 'position:absolute;right:2px;top:2px;background:rgba(0,0,0,0.6);color:#fff;font-size:12px;line-height:12px;width:14px;height:14px;text-align:center;border-radius:50%;cursor:pointer');

          const thumb = document.createElement("img");
          thumb.src = dataUrl;
          thumb.setAttribute('style', 'width: 50px;height: 50px;border:3px solid #d2d6de;border-radius:6px');

          closeBtn.addEventListener('click', () => {
            try { wrapper.remove(); } catch {}
            const linkIdx = this.dataLink.indexOf(dataUrl);
            if (linkIdx > -1) this.dataLink.splice(linkIdx, 1);
            const allIdx = this.allScreenshots.findIndex(s => s.id === id);
            if (allIdx > -1) this.allScreenshots.splice(allIdx, 1);
          });

          wrapper.appendChild(thumb);
          wrapper.appendChild(label);
          wrapper.appendChild(closeBtn);
          this.ScreenshotFromVideo.prepend(wrapper);

          $("#screenshot").css({
            'padding':'10px',
            'overflow':'auto',
            'white-space':'nowrap',
            'border':'1px solid #ddd',
            'border-radius':'5px',
            'margin-top':'5px',
            'margin-bottom':'5px'
          });
        };

        $("#capture").off('click').on('click', captureImage);
        this.hasBoundCaptureHandler = true;
      }
    };
    initializeScreenshot();
  }



  GeneratePdf() {
    if (!this.dataLink || this.dataLink.length === 0) { return; }
    //const reqNo = 'SEND DAMAGED/REPAIRED VIDEOS FOR REGNo - ' + this.ClaimDetail.RegistrationNo;
    const fileSave = 'DAMAGED/REPAIRED_VIDEO_SNAPS_' + this.ClaimDetail.RegistrationNo + '.pdf';
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    this.newPDFDoc = doc;
    doc.setFontSize(15);
    doc.text('Video Snaps Report For - ' + this.ClaimDetail.RegistrationNo , 35, 25);

    const pageWidth = doc.internal.pageSize.getWidth();
    const leftMargin = 15;
    const rightMargin = 15;
    const usableWidth = pageWidth - leftMargin - rightMargin;
    const imageHeight = 80; // fixed height for thumbnails
    let y = 30;

    const addImageOrPageBreak = (imgData: string) => {
      if (y + imageHeight > doc.internal.pageSize.getHeight() - 10) {
        doc.addPage();
        y = 15;
      }
      doc.addImage(imgData, 'JPEG', leftMargin, y, usableWidth, imageHeight, undefined, 'FAST');
      y += imageHeight + 10;
    };

    for (const img of this.dataLink) {
      addImageOrPageBreak(img);
    }
    doc.save(fileSave.trim());
  }

  takeScreennstp() {

    // if (this.clickCount > 0) {
    //     return
    // }
    // this.clickCount += 1
    this.captureDisablednstp = false
    this.screenshotDisablednstp = true

    // $("#capture").disabled = false;
    // $("#capture").className = "btn btn-primary";
    // $("#screen").disabled = true;
    // $("#screen").className = "btn btn-primary disabled";


    let initializeScreenshot = ()=> {
      this.ScreenshotFromVideo = $("#screenshotnstp");
      this.Video = $("#inspectionVideo").get(0);
      $("#capturenstp").off('click').on('click',captureImage);
    };

    let captureImage = ()=> {
      this.canvas = document.createElement("canvas");
      this.canvas.width = this.Video.videoWidth;
      this.canvas.height = this.Video.videoHeight;
      this.canvas.getContext('2d')
            .drawImage(this.Video, 0, 0, this.canvas.width, this.canvas.height);
      this.canvas.setAttribute('crossOrigin', 'anonymous');
      let quality = 0.4;
      try {
        const qualitySel: any = document.getElementById('quality');
        if (qualitySel && qualitySel.value) {
          const parsed = parseFloat(qualitySel.value);
          if (!isNaN(parsed)) quality = parsed;
        }
      } catch {}
      const dataUrl = this.canvas.toDataURL('image/jpeg', quality);
      this.dataLinknstp.push(dataUrl);

      const id = Date.now().toString() + Math.random().toString(36).slice(2);
      const vidIdx = this.currentInspectionVideoIndex >= 0 ? this.currentInspectionVideoIndex : 0;
      this.allScreenshots.push({ id, src: dataUrl, source: 'inspection', videoIndex: vidIdx });

      const wrapper = document.createElement('div');
      wrapper.setAttribute('data-id', id);
      wrapper.setAttribute('style', 'position: relative; display: inline-block; margin: 0 5px;');

      const label = document.createElement('span');
      label.textContent = 'V' + String(vidIdx + 1);
      label.setAttribute('style', 'position:absolute;left:2px;top:2px;background:#007bff;color:#fff;font-size:10px;padding:1px 3px;border-radius:3px');

      const closeBtn = document.createElement('span');
      closeBtn.textContent = '×';
      closeBtn.setAttribute('title','Remove');
      closeBtn.setAttribute('style', 'position:absolute;right:2px;top:2px;background:rgba(0,0,0,0.6);color:#fff;font-size:12px;line-height:12px;width:14px;height:14px;text-align:center;border-radius:50%;cursor:pointer');

      const thumb = document.createElement("img");
      thumb.src = dataUrl;
      thumb.setAttribute('style', 'width: 50px;height: 50px;border:3px solid #d2d6de;border-radius:6px');

      closeBtn.addEventListener('click', () => {
        try { wrapper.remove(); } catch {}
        const linkIdx = this.dataLinknstp.indexOf(dataUrl);
        if (linkIdx > -1) this.dataLinknstp.splice(linkIdx, 1);
        const allIdx = this.allScreenshots.findIndex(s => s.id === id);
        if (allIdx > -1) this.allScreenshots.splice(allIdx, 1);
      });

      wrapper.appendChild(thumb);
      wrapper.appendChild(label);
      wrapper.appendChild(closeBtn);
      this.ScreenshotFromVideo.prepend(wrapper);
      $("#screenshotnstp").css('padding','10px');
      $("#screenshotnstp").css('overflow','auto');
      $("#screenshotnstp").css('white-space','nowrap');
      $("#screenshotnstp").css('border', '1px solid #ddd');
      $("#screenshotnstp").css('border-radius','5px');
      $("#screenshotnstp").css('margin-top', '5px');
      $("#screenshotnstp").css('margin-bottom','5px');

    };
    initializeScreenshot();
  }



  GeneratePdfnstp() {
    if (!this.dataLinknstp || this.dataLinknstp.length === 0) { return; }
    //const reqNo = 'SEND INSPECTION VIDEOS FOR REGNo- ' + this.ClaimDetail.RegistrationNo;
    //const fileSave = 'INSPECTION VIDEOS_' + this.inspectionId + '.pdf';
    const fileSave = 'INSPECTION_VIDEO_SNAPS_' + this.ClaimDetail.RegistrationNo + '.pdf';
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    this.newPDFDoc = doc;
    doc.setFontSize(15);
    doc.text('Video Inspection Report For - ' + this.ClaimDetail.RegistrationNo ,35, 25);

    const pageWidth = doc.internal.pageSize.getWidth();
    const leftMargin = 15;
    const rightMargin = 15;
    const usableWidth = pageWidth - leftMargin - rightMargin;
    const imageHeight = 80;
    let y = 30;

    const addImageOrPageBreak = (imgData: string) => {
      if (y + imageHeight > doc.internal.pageSize.getHeight() - 10) {
        doc.addPage();
        y = 15;
      }
      doc.addImage(imgData, 'JPEG', leftMargin, y, usableWidth, imageHeight, undefined, 'FAST');
      y += imageHeight + 10;
    };

    for (const img of this.dataLinknstp) {
      addImageOrPageBreak(img);
    }
    doc.save(fileSave.trim());
  }

  GenerateCombinedPdf() {
    const existingShots = (this.allScreenshots || []).filter(s => s.source === 'existing');
    if (existingShots.length === 0) { return; }
    const title = 'Combined Damaged/Repaired Video Screenshots';
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    this.newPDFDoc = doc;
    doc.setFontSize(15);
    doc.text(title, 35, 25);

    const pageWidth = doc.internal.pageSize.getWidth();
    const leftMargin = 15;
    const rightMargin = 15;
    const usableWidth = pageWidth - leftMargin - rightMargin;
    const imageHeight = 80;
    let y = 30;

    const addWithCaption = (imgData: string, caption: string) => {
      const captionHeight = 6;
      const needed = captionHeight + imageHeight + 10;
      if (y + needed > doc.internal.pageSize.getHeight() - 10) {
        doc.addPage();
        y = 15;
      }
      doc.setFontSize(11);
      doc.text(caption, leftMargin, y);
      y += captionHeight;
      doc.addImage(imgData, 'JPEG', leftMargin, y, usableWidth, imageHeight, undefined, 'FAST');
      y += imageHeight + 10;
    };

    for (const s of existingShots) {
      const label = 'Video ' + String(s.videoIndex + 1) + (s.source === 'inspection' ? ' (Inspection)' : '');
      addWithCaption(s.src, label);
    }
    const fileName = 'All_Damaged_Repaired_Snaps_PB' + (this.ClaimDetail.ClaimId || '') + '.pdf';
    doc.save(fileName);
  }

  GenerateCombinedPdfInspection() {
    const inspShots = (this.allScreenshots || []).filter(s => s.source === 'inspection');
    if (inspShots.length === 0) { return; }
    const title = 'Combined Inspection Video Screenshots';
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    this.newPDFDoc = doc;
    doc.setFontSize(15);
    doc.text(title, 35, 25);

    const pageWidth = doc.internal.pageSize.getWidth();
    const leftMargin = 15;
    const rightMargin = 15;
    const usableWidth = pageWidth - leftMargin - rightMargin;
    const imageHeight = 80;
    let y = 30;

    const addWithCaption = (imgData: string, caption: string) => {
      const captionHeight = 6;
      const needed = captionHeight + imageHeight + 10;
      if (y + needed > doc.internal.pageSize.getHeight() - 10) {
        doc.addPage();
        y = 15;
      }
      doc.setFontSize(11);
      doc.text(caption, leftMargin, y);
      y += captionHeight;
      doc.addImage(imgData, 'JPEG', leftMargin, y, usableWidth, imageHeight, undefined, 'FAST');
      y += imageHeight + 10;
    };

    for (const s of inspShots) {
      const label = 'Video ' + String(s.videoIndex + 1) + ' (Inspection)';
      addWithCaption(s.src, label);
    }
    const fileName = 'All_Inspection_Snaps_PB' + (this.ClaimDetail.ClaimId || '') + '.pdf';
    doc.save(fileName);
  }

}
